<template>
  <div class="index">
    <div class="information-container">
      <div class="centered add-document">
        <span class="button-wrapper link" @click="addNormativeAct()">
          <a class="button is-info">+</a> Добавить ресурс
        </span>
      </div>
      <draggable class="columns is-multiline documents" v-if="documentsData" v-model="documentsData">
        <NormativeActItem v-for="document in documentsData" :object="document" :key="document.id"/>
      </draggable>
    </div>
  </div>
</template>

<script>
import NormativeActItem from 'components/Information/NormativeActItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import draggable from 'vuedraggable'

export default {
  name: 'InformationDocuments',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['documents']),
    documentsData: {
      get () {
        return deepcopy(this.documents)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.updateAllNormativeActs(val)
      }
    }
  },
  created () {
    this.getNormativeActs()
  },
  methods: {
    ...mapActions(['getNormativeActs', 'addNormativeAct', 'updateAllNormativeActs'])
  },
  components: { NormativeActItem, draggable }
}
</script>

<style scoped>
.information-container {
  padding: 25px 90px 60px;
  margin: 15px 0 0;
  max-width: 1368px;
  margin: 0 auto;
}
.documents {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// NormativeActs.vue?7037d0da